import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './improving-wire-edm/HeroSection';
import { IntroSection } from './improving-wire-edm/IntroSection';
import { RegularMaintenanceSection } from './improving-wire-edm/RegularMaintenanceSection';
import { OEMPartsSection } from './improving-wire-edm/OEMPartsSection';
import { OEMContractsSection } from './improving-wire-edm/OEMContractsSection';
import { OperatorTrainingSection } from './improving-wire-edm/OperatorTrainingSection';
import { ToolingSection } from './improving-wire-edm/ToolingSection';
import { LightsOutSection } from './improving-wire-edm/LightsOutSection';
import { TwinWireSection } from './improving-wire-edm/TwinWireSection';
import { NextMoveSection } from './improving-wire-edm/NextMoveSection';
import { BottomLinksSection } from './improving-wire-edm/BottomLinksSection';
export function ImprovingWireEDMPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3088">
      <SeoBar data-id="element-3089" />
      <Header data-id="element-3090" />
      <main className="flex-grow" data-id="element-3091">
        <div className="w-full bg-gray-50 pb-20" data-id="element-3092">
          <HeroSection data-id="element-3093" />
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-3094">
            <IntroSection data-id="element-3095" />
            <RegularMaintenanceSection data-id="element-3096" />
            <div className="grid md:grid-cols-2 gap-8" data-id="element-3097">
              <OEMPartsSection data-id="element-3098" />
              <OEMContractsSection data-id="element-3099" />
            </div>
            <OperatorTrainingSection data-id="element-3100" />
            <ToolingSection data-id="element-3101" />
            <LightsOutSection data-id="element-3102" />
            <TwinWireSection data-id="element-3103" />
            <NextMoveSection data-id="element-3104" />
            <BottomLinksSection data-id="element-3105" />
          </div>
        </div>
      </main>
      <Footer data-id="element-3106" />
    </div>;
}